























import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { Feature, MultiPolygon, Polygon } from 'geojson';
import { useEditArea } from '@/store/modules/areas';
import AreaDrawEditor from './AreaDrawEditor.vue';
import AreaDrawReview from './AreaDrawReview.vue';
import { unfinalizeArea } from './drawUtils';

enum AreaDrawSteps {
	Editor = 'EDITOR',
	Review = 'REVIEW',
}

export default defineComponent({
	components: {
		AreaDrawEditor,
		AreaDrawReview,
	},
	emits: ['close', 'submit'],
	props: {
		area: {
			type: Object as () => Feature<MultiPolygon>,
			required: true,
		},
	},
	setup(props, { root, emit }) {
		const step = ref<AreaDrawSteps>();
		const drawArea = ref<Feature<MultiPolygon> | undefined>(props.area ?? undefined);
		const drawFeatures = ref<Feature<Polygon>[]>(props.area ? unfinalizeArea(props.area) : []);
		const { editArea, clearError, isLoading, hasError } = useEditArea(root.$store);

		const handleBack = () => {
			step.value = AreaDrawSteps.Editor;
		};

		const handleNext = (finalizedArea: Feature<MultiPolygon>) => {
			drawArea.value = finalizedArea;
			step.value = AreaDrawSteps.Review;
		};

		const handleSubmit = async () => {
			clearError();

			if (!props.area.id || !drawArea.value) {
				return;
			}

			const success = await editArea({
				...drawArea.value,
				id: String(props.area.id),
				properties: {
					name: props.area.properties?.name,
					description: props.area.properties?.description,
				},
			});

			if (success) {
				root.$store.dispatch('resources/getAllResources');
				emit('close');
			}
		};

		// Map is not rendered correctly because dialog transition, so, set delay to make it work
		onMounted(() => {
			setTimeout(() => (step.value = AreaDrawSteps.Editor), 350);
		});

		return {
			step,
			AreaDrawSteps,
			drawArea,
			drawFeatures,
			isLoading,
			hasError,
			handleBack,
			handleNext,
			handleSubmit,
		};
	},
});
